import { render, staticRenderFns } from "./knowledgeView.vue?vue&type=template&id=3fb945be&"
import script from "./knowledgeView.vue?vue&type=script&lang=ts&"
export * from "./knowledgeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports